module.exports = __webpack_public_path__ + "img/logo.f0f93e80.svg";